var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden"},[_c('v-app',[_c('DashboardHeader'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('OnboardingFooter'),_vm._v(" "),_c('Snackbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }